module.exports = __webpack_public_path__ + "static/grape-f34eb5e46e064537709f57addbebf18a.png";